import { SerializedError } from "@reduxjs/toolkit";

export class ApiError extends Error implements SerializedError {
  code: string;
  context?: Record<string, string>;
  constructor(code: number, message: string, context?: Record<string, string>) {
    super(message);

    this.name = this.constructor.name;
    this.code = code?.toString();
    this.context = context;
  }
}
